import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { API } from "../../helper/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RotatingLines } from "react-loader-spinner";
import Footer from "../common/Footer";
import Header from "../common/Header";
import SessionHandler from "../common/SessionHandler";
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";


function ShopifyProducts() {
  const [items, setItems] = useState([]);
  const [singleitems, setSingleitems] = useState([]);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pending, setPending] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [newPrice, setNewPrice] = useState(0);
    const [limit, setLimit] = useState(50);
    const [storeIdToFilter, setStoreIdToFilter] = useState(991);
    // const [currentPageInfo, setCurrentPageInfo] = useState(null);
    const navigate = useNavigate();
    const [hasNextPage, setHasNextPage] = useState(true);
    const [PreviousPage, setHasPreviousPage] = useState(true);
    const [nextCursor, setNextCursor] = useState(null);
    const [clickAction, setClickAction] = useState(null);
    const [previousCursor, setPreviousCursor] = useState(null);
    const [totalProducts, setTotalProducts] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(50);
    const [currentPage, setCurrentPage] = useState(1); // Track current page number
  const [showDatePickerModal, setShowDatePickerModal] = useState(false);
  const [track1, setTrack1] = useState(false);
  const [hideDirector, setHideDirector] = React.useState(false);

    const [loading, setLoading] = useState(false);


      const getProducts = (nextCursor,previousCursor,clickAction,limit) => {
        setPending(true);
        API.getShopifyProducts({storeIdToFilter,nextCursor,previousCursor,clickAction,limit})
          .then((data) => {
            setItems(data.products);
            const pageInfo = data.pageInfo;
            setHasNextPage(pageInfo.hasNextPage);
            setHasPreviousPage(pageInfo.hasPreviousPage);
            setNextCursor(pageInfo.endCursor);
            setPreviousCursor(pageInfo.startCursor);
            setTotalProducts(data.totalProducts);
            setPending(false);
            // API.DataTableScript();
          })
          .catch((err) => console.log(err));
      };

      const columns = React.useMemo(() => [
        {
          name: 'Title',
          selector: 'title',
          sortable: true,
        },
        {
          name: 'Director',
          selector: 'director',
          sortable: true,
          omit: hideDirector,
        },
        {
          name: 'Year',
          selector: 'year',
          sortable: true,
        },
      ], [hideDirector]);

  // useEffect(() => {
  //   if (items.length > 0) {
  //    return  API.DataTableScript();
  //   }
  // }, [items]);

//   const toggleModal = () => {
//     setShowModal(!showModal);
//   };
  const openModal = (store_id,product_legacyResourceId) => {
    setShowModal(true);

    API.getShopifySpecificProduct({store_id,product_legacyResourceId})
    .then((data) => {
      setSingleitems(data);
      setPending(false);

    })
    .catch((err) => console.log(err));


  }

  const closeModal = () => {
    setShowModal(false);
  };


  const updatePrice = (store_id,productVariant_legacyResourceId) => {

    API.getShopifySpecificProductPriceUpdate({store_id,productVariant_legacyResourceId,newPrice})
    .then((response) => {
const usererror = response.data.productVariantUpdate.userErrors;

if (Array.isArray(usererror) && usererror.length > 0) {
  toast.error("Something went wrong. Please try again.", {
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
  });
} else {
  toast.success("Product Updated", {
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
  });

  setTimeout(() => {
    window.location.reload();// Navigate after the toast finishes
  }, 500);
}


      setPending(false);

    })
    .catch((err) => console.log(err));
};


const formatPriceToUSD = (price) => {
  const priceNumber = parseFloat(price.replace(/[^0-9.-]+/g, ""));
  return `$${priceNumber.toFixed(2)}`;
};

  // const finalfilteredProducts = items.filter(product => product.store_id
  //   === storeIdToFilter);
  const handleStoreChange = (event) => {
    setClickAction(null);
    setNextCursor(null);
    setPreviousCursor(null);
    setStoreIdToFilter(Number(event.target.value));
  };

  // const handlePageChange = (event) => {
  //   // console.log(event)
  //   // if (currentPageInfo) {
  //     getProducts(nextCursor,limit);
  //   // }
  // };

  const handleRowsPerPageChange = (event) => {
    setLimit(event.target.value); 
    setNextCursor(null);
    setPreviousCursor(null);
    setCurrentPage(1);
    getProducts(null, null, 'reset', event.target.value);
  };
  const handlePreviousClick = () => {
    if (PreviousPage) {
      setClickAction("previous")
      setCurrentPage((prevPage) => prevPage - 1);
      getProducts(nextCursor, previousCursor, 'previous', limit);
    }
  };
  // const handleFastPreviousClick = () => {
  //   if (PreviousPage) {
  //     setClickAction("fastprevious")
  //     getProducts(nextCursor,previousCursor,clickAction,limit);
  //   }
  // };
  const handleNextClick = () => {
    if (hasNextPage) {
      setClickAction("next")
      setCurrentPage((prevPage) => prevPage + 1);
      getProducts(nextCursor, previousCursor, 'next', limit);
    }
  };  
  // const handleFastNextClick = () => {
  //   if (hasNextPage) {
  //     setClickAction("fastnext")
  //     getProducts(nextCursor,previousCursor,clickAction,limit);
  //   }
  // };  

  const calculateRange = () => {
    const startIndex = (currentPage - 1) * limit + 1;
    const endIndex = Math.min(currentPage * limit, totalProducts);

    if (startIndex > totalProducts) {
      return `0-${totalProducts}`;
    }

    return `${startIndex}-${endIndex}`;
  };


  useEffect(() => {
    getProducts(nextCursor,previousCursor,clickAction,limit);
  }, [storeIdToFilter,clickAction,limit]);


  const showvisibilityModal = () => {
    
    setShowDatePickerModal(true);
  };
  let track=false;

  const toggleColumn = (id) => {
    console.log(columns)
   // return false
    // setColumns((prev) =>
    //   prev.map((col) =>
    //     col.id === id ? { ...col, columnVisible: !col.columnVisible } : col
    //   )
    // );
   setTrack1(true);
    console.log("toggle",columns)
  };


  useEffect(() => {
    track=true;
    const savedColumnOrder = Cookies.get('ProductsOrder2');
   if(savedColumnOrder){
    const convertJson=JSON.parse(savedColumnOrder);
    const updatedColumns = updateOriginalColumns(convertJson);
   
    const updatedColumnBasedOnCookies = updatedColumns.map((item) => {
        let updatedItem = { ...item }; // Create a new object to avoid mutation
    
        let isVisible = false; // Default to false
        convertJson.forEach((it) => {
            if (it.id === item.id && it.columnVisible === true) {
                isVisible = true;
            }
        });
    
        updatedItem.columnVisible = isVisible; // Set the correct value
        return updatedItem; // Return the new object
    });

     
   }
  }, []);

  const updateOriginalColumns = (reordered) => {
    // Map the reordered columns to their ids
    const reorderedOrder = reordered.map((col) => col.id);

    // Reorder original columns based on the reorderedOrder
    const updatedColumns = columns
      .sort((a, b) => reorderedOrder.indexOf(a.id) - reorderedOrder.indexOf(b.id));
    return updatedColumns;
  };

    return (
   <>
    
      <ToastContainer
        position="top-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />


      <div class="container-fluid page-body-wrapper">
            <div class="main-panel">
        <div class="content-wrapper">
        <div >
          {/* <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer={true}
            onChangePage={handleRowClicked}
            paginationTotalRows={totalRecords}
            paginationPerPage={10}
            progressPending={pending}
          /> */}
<div class="shopify_Card_contend">



        {/* Modal for password reset */}
        {showDatePickerModal ? (
          <div
           className="columnvisible_bg"
            onClick={() => setShowDatePickerModal(false)}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "1rem",
                borderRadius: "5px",
                width: "818px",
                marginTop: "40px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
              onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside
            >
                   {/* <h5 className="text-center">Column visibility control</h5> */}
                   <div className="row" >
                    {console.log("col",columns)}
  {columns.map((col, index) => (
    col.name !=="CLU" ? (<div className="col-md-3 customVisible"  id={col.id} onClick={() => toggleColumn(col.id)}>
      {/* <input type="checkbox" id={col.id}  checked={col.columnVisible}
      onChange={() => toggleColumn(col.id)}  /> */}
      <label >{col.name}{col.columnVisible ===true &&<span style={{position:"absolute",right:"1em"}}>✓</span>}</label>

  </div>):(null)
    
 
//    <div key={index} className="col-6 d-flex align-items-center">
//       {/* Checkbox first */}
//       <input
//         type="checkbox"
//         className="form-check-input me-2"
//         id={col}
//         // checked={col.isVisible}
//         onChange={() => toggleColumn(col)}
//       />
//       {/* Label follows the checkbox */}
//       <span className="form-check-label" htmlFor={col}>
//         {col}
//       </span>
//     </div>
  ))}
</div>

            
            </div>
          </div>
        ) : null}




                     {/* Modal */}
                     <div
                        className={`modal fade ${showModal ? "show" : ""}`}
                        tabIndex="-1"
                        style={{ display: showModal ? "block" : "none" }}
                        aria-hidden={!showModal}
                      >
                        <div className="modal-dialog modal-lg">
                          {" "}
                          {/* Add modal-lg class here for large modal */}
                          <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                              <h5 className="modal-title">
                                Product Details
                              </h5>

                              <button  type="button"  className="close" onClick={closeModal} >
                                <span aria-hidden="true">&times;</span>
                              </button>

                            </div>

                            {/* Modal Body */}
                            <div className="modal-body">
  
                              <div class="modal-body">
                                <div >


                                {singleitems.length > 0 ? (
                                    singleitems.map((singleitem, index) => (
                                      <>  
                                        <div class="grid" key={index}>
                                            <label>Product Name: </label>
                                            <input type="text" id="myText" value={singleitem.product_title}/>
                                            <label>Product SKU:</label><input type="text" value={singleitem.sku}/>
                                            <label>Old Price:</label><input type="email" value={singleitem.price}/>
                                            <label>New Price:</label><input type="text" onChange={(e) => setNewPrice(e.target.value ? e.target.value : singleitem.price)}  required/>
                                        </div> 
                                        <div className="priceUpdateBtn">
                                        <button  class="btn btn-primary" onClick={() => updatePrice(singleitem.store_id,singleitem.productVariant_legacyResourceId)}>Update Price</button>
                                        </div>       
                                       </>                                
                                    ))
                                ) : (
                                    <p>No products available</p> // Show a message if the array is empty
                                )}

                                </div>
                              </div>



                            </div>


                          </div>
                        </div>
                      </div>

                      <div className="store_dropdown">
                      <label htmlFor="storeId">Select Store:</label>
                      <select id="storeId" onChange={handleStoreChange} value={storeIdToFilter}>
                        <option value={991}>ledevteam</option>
                        <option value={992}>ledevteam2</option>
                        <option value={993}>learning-express-test-store</option>
                      </select>
                  </div>

                  <button
                  style={{marginLeft:"10px"}}
          className="btn btn-secondary dropdown-toggle"
          type="button"
          onClick={showvisibilityModal}
        >
          Column visibility
        </button>

            {pending ? (
              <div className="loader">
                <RotatingLines
                  visible={true}
                  height="96"
                  width="96"
                  strokeColor="grey"
                  strokeWidth="2"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                />
              </div>
            ) : (
              <div>
                {!pending ? ( 
                  <>
                  <div className="ProductList">
                  <div className="totalRecord" style={{marginBottom: "15px"}}>
                  <span style={{color:"#000",fontWeight:"600"}}>Total : {totalProducts} records found</span>
                  </div>
                  <button onClick={() => setHideDirector(!hideDirector)}>Hide Directory Column</button>
      <DataTable
        title="Movie List"
        columns={columns}
        data={items}
      />

                  </div>


                 {/* <table id="myTable1" className="row-border">           
                      <thead>
                        <tr>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Item#</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Description</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>NSO</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Curr.Catalog</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Category#</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Vendor Code</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Cost</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Price</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Pack</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>QtyOH</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>QtyOO</th>
                        <th style={{fontWeight:"bold",color: "#665d5d"}}>Status</th>
                        </tr>
                      </thead>
                        <tbody>
                          {items.map((item, index) => (
                            <tr>
                              <td> <a href="#" onClick={() => openModal(item.store_id,item.product_legacyResourceId)}>{item.sku ? item.sku : ''}</a></td>
                              <td>{item.product_title ? item.product_title : ''}</td>
                              <td style={{textAlign:"center"}}>{item['metafields'].nso == 'true' ? <span className="mdi mdi-checkbox-marked-circle nso_true"></span> : <span className="disableNSO">N</span>}</td>
                              <td>{item['metafields'].catalog ? item['metafields'].catalog : ''}</td>
                              <td style={{textAlign:"right"}}>{item['metafields'].le_category_id ? item['metafields'].le_category_id : ''}</td>
                              <td>{item.vendor ? item.vendor : ''}</td>
                              <td style={{textAlign:"right"}}>{item.cost ? formatPriceToUSD(item.cost['amount']) : ''}</td>
                              <td style={{textAlign:"right"}}>{item.price ? formatPriceToUSD(item.price) : ''}</td>
                              <td style={{textAlign:"right"}}>{item['metafields'].pack ? item['metafields'].pack : ''}</td>
                              <td style={{textAlign:"right"}}>{item.onHand ? item.onHand : ''}</td>
                              <td style={{textAlign:"right"}}>{item.otyoo ? item.otyoo : ''}</td>
                              <td>{item.status ? item.status : ''}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table> */}

                  </>

                ): null} 
              </div>
            )}
    <div className="paginationContent">
      <div className="paginationButtons">
      {!pending ? (
        <>
  
        <div className="rowPerPage">
          <label htmlFor="rows-per-page">Rows per page: </label>
          <select
            id="rows-per-page"
            value={limit}
            onChange={handleRowsPerPageChange}
          >
            {[50, 100, 150, 200].map((rows) => (
              <option key={rows} value={rows}>
                {rows}
              </option>
            ))}
          </select>
        </div>      

        {calculateRange()} of {totalProducts}


        </>

          ) : null}


        {/* Pagination Buttons */}
        <button
          // onClick={handleFastPreviousClick}
          disabled={!PreviousPage || pending}
          className="paginationBtn"
        >
          {pending ? '' : <i class="fa fa-fast-backward" aria-hidden="true"></i>}
        </button>
        <button
          onClick={handlePreviousClick}
          disabled={!PreviousPage || pending}
          className="paginationBtn"
        >
          {pending ? '' : <i class="fa fa-step-backward" aria-hidden="true"></i>}
        </button>
        <button
          onClick={handleNextClick}
          disabled={!hasNextPage || pending}
          className="paginationBtn"
        >
          {pending ? '' : <i class="fa fa-step-forward" aria-hidden="true"></i>}
        </button>
        <button
          // onClick={handleFastNextClick}
          disabled={!hasNextPage || pending}
          className="paginationBtn"
        >
          {pending ? '' : <i class="fa fa-fast-forward" aria-hidden="true"></i>}
        </button>
      </div>
    </div>

            </div>



        </div>
 
        </div>
        </div>
        </div>
    
      
    </>
    );
}

export default ShopifyProducts;